/**
 * Widget session state in localStorage.
 *
 * Keys:
 *   apaxir_visitor_id        — stable UUID per device/browser (persisted across bots)
 *   apaxir_conv_{botId}      — conversation id for a specific bot, cleared on reset
 */

const VISITOR_KEY = 'apaxir_visitor_id';
const convKey = (botId: string) => `apaxir_conv_${botId}`;

export function getOrCreateVisitorId(): string {
  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
}

export function getConversationId(botId: string): string | null {
  return localStorage.getItem(convKey(botId));
}

export function setConversationId(botId: string, id: string): void {
  localStorage.setItem(convKey(botId), id);
}

export function clearConversation(botId: string): void {
  localStorage.removeItem(convKey(botId));
}
